import React, { Component } from 'react';

import FormField from '../form-field/FormField';
import './style.css';


export default class FLNames extends Component {
  render() {
    const classes = this.props.styleClasses ? this.props.styleClasses.join(' ') : '';
    return (
      <div className={classes + ' form__info-block'}>
        <div className='form__tips'>
          Укажите имя и&nbsp;фамилию на&nbsp;русском языке. Их&nbsp;напечатают на&nbsp;вашем бейдже.
        </div>
        <div className='form__inputs'>
          <FormField
            title='Имя' type='text' clearFields={this.props.clearFields}
            fieldName='firstName' errorHandler={this.props.firstNameHandler}
            defaultValue={this.props.firstName}
          />
          <FormField
            title='Фамилия' type='text' clearFields={this.props.clearFields}
            fieldName='lastName' errorHandler={this.props.lastNameHandler}
            defaultValue={this.props.lastName}
          />
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/blocks/form-blocks/FLNames.js